const toArray = function (value) {
    if (Array.isArray(value)) return value;
    if (value == null) return [];
    return [value];
}
export { toArray };